<template>
  <div id="emissions_atmospheric_air_ship">
    <div v-if="receivedData.first">
      <TabsCustomGraphic 
        :received-data="receivedData.first"
        :data-labels="false"
        id="emissions_atmospheric_first"
      />
    </div>
    <div v-if="receivedData.second">
      <TabsCustomGraphic 
        :received-data="receivedData.second"
        :data-labels="false"
        id="emissions_atmospheric_second"
      />
    </div>
  </div>
</template>
<script>

import CMS from '@/model/cms'
import Service from '@/service/service.js'
import { mapGetters } from 'vuex'

export default {
  name: 'EmissionsAtmosphericAir',

  components: {
    TabsCustomGraphic: () => import('@/components/graph/TabsCustomGraphic.vue'),
  },

  data () {
    return {
      receivedData: {
        first: null,
        second: null
      },
      blockId: 'emissions_atmospheric_air',
      cloneElementId: 'emissions_atmospheric_air_ship'
    }
  },

  mounted () {
    this.getGraphData()
    Service.elementClone(this.blockId, this.cloneElementId)
  },

  computed: {
    ...mapGetters({
      userToken: 'getUserToken'
    }),
  },

  methods: {
    getGraphData() {
      CMS.getGraph(this.userToken, '1,2,3,4,5').then((response) => {
        this.receivedData.first = []
        this.receivedData.second = []
        this.receivedData.first[0] = response.data[0]
        this.receivedData.first[1] = response.data[1]
        this.receivedData.second[0] = response.data[2]
        this.receivedData.second[1] = response.data[3]
        this.receivedData.second[2] = response.data[4]
      })
    }
  }
}
</script>